module.exports = __webpack_public_path__ + "img/megadisplay.256b3947.jpg";